import { render, staticRenderFns } from "./TerragruntIcon.vue?vue&type=template&id=0d5534a2"
import script from "./TerragruntIcon.vue?vue&type=script&lang=js"
export * from "./TerragruntIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports